import { useEffect, useState } from "react"
import { Flex } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import { Text } from "@/components/wrappers/Aria/AriaWrapper.tsx"

export function CurrentTime() {
  const [date, setDate] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date())
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  })

  return (
    <Text className="text-5xl font-bold" style={{ color: "#1e74ad" }}>
      {date.toLocaleTimeString("en-IN")}
    </Text>
  )
}

export function CurrentDate() {
  const date = new Date()
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  }
  return (
    <Text className="text-2xl">
      {date.toLocaleDateString("en-IN", options)}
    </Text>
  )
}

export function Clock() {
  return (
    <Flex direction="column" alignItems="center" justifyContent="center">
      <CurrentTime />
      <CurrentDate />
    </Flex>
  )
}
